<template>
  <div>
  <div :dependentComputedProps="{ appConfig }"></div>
  <div class="menu-header-wrap plr16" id="pageTop">
    <div 
      id="menu-header" 
      class="menu-header-bar focussed plr16 mb16"
      :style="getBackgroundImage"
    >
      <i @click="redirectToPreviousPage()" class="jfi-back-v2"></i>
      <span class="menu-heading">Domino's Pizza</span>
      <button
        @click.prevent="triggerSearchModal($event)"
        class="menu-header-query-submit"
        id="searchCta"
        type="submit"
        name="searchCta"
      >
        <div class="menu-search-icon">
          <i class="jfi-search"></i>
        </div>
      </button>
    </div>

    <!-- search modal -->
    <div class="search-wrap">
      <search-modal
        v-if="isSearchModalOpen"
        :showSearchModal="isSearchModalOpen"
        :moduleProps="moduleProps"
        @close="closeSearchModal()"
      ></search-modal>
    </div>

    <!-- menu popup -->
    <new-menu-modal
      v-if="!isFloatingMenuVariant()"
    ></new-menu-modal>
    <!-- offer shown modal -->
    <!-- <offer-shown-modal></offer-shown-modal> -->
  </div>
  <alert-popup v-if="showAlertModal"></alert-popup>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import setEvents, { loadAmplitudeUnsentEvents } from "../helpers/events";
import UserActivityTracking from "../helpers/UserActivityTracking";
import { getExperimentsPromiseArray } from "../helpers/vwoSetup";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  v2PwaBasePath,
  projectBasePathWithFolder,
  shouldLoginFlowSkip
} from "../config/apiEndpoints";
import { 
  keyMapsMutation, 
  keyMapsGetter,
  keyMapsAction
} from "../helpers/storeKeys";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import OfferShownModal from "./OfferShownModal.vue";

export default {
  name: "PageHeader",
  props: ["moduleProps"],
  components: {
    SearchModal: defineAsyncComponent(() => import("./SearchModal.vue")),
    NewMenuModal: defineAsyncComponent(() =>
      import("./BottomBarNewMenuModal.vue")
    ),
    OfferShownModal,
    AlertPopup: defineAsyncComponent(() =>
      import("./AlertPopup.vue")
    ),
  },
  data() {
    return {
      amplitudeTimeSpentIsNotProcessed: true,
      modulePropsData : {},
    };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
        
    let isVwoVariantAvailable = true;
    let vwoVariant = "";
    const placeHolderImg_sq = this.modulePropsData?.placeHolder_sq;
    const placeHolderImg_rect = this.modulePropsData?.placeHolder_rect;
    this.$store.commit(keyMapsMutation.UPDATE_PLACE_HOLDER_IMAGE, {
      square: placeHolderImg_sq,
      rect : placeHolderImg_rect
      }
    );
    await Promise.all([...getExperimentsPromiseArray()])
      .then((data) => {
        let __ = document.getElementsByClassName("pg-wrapper");
        if (__?.length > 0) {
          let ___ = {};

          data.forEach((element) => {
            for (let key in element) {
              if (key && element[key]) {
                __[0].classList.add(`${key.replace(/\s/g, '')}-${element[key]}`);
              }
              ___[key] = element[key];
            }
          });
          if (
            !LocalStorageFunc.isLoggedIn() &&
            !LocalStorageFunc.getSessionStorageKey("LOGIN_FLOW_SKIP") &&
            shouldLoginFlowSkip
          ) {
            const loginPageUrl = `/${window?._siteProps_?.props?.postorderUIBasepath}login`;
        window.location.href =
          `${v2PwaBasePath}${loginPageUrl}` + Utility.getUrlQueryString();
           this.$store.commit(keyMapsMutation.REMOVE_LOYALTY_CART_ITEMS, null);
          }
          if (
            !Utility.checkNextgenVariant(___[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT])
          ) {
            isVwoVariantAvailable = false;
            LocalStorageFunc.unsetSessionStorageKey("nextgenhomepage");
            window.location.href = v2PwaBasePath + Utility.getUrlQueryString();
            return;
          }
          vwoVariant = ___[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
          this.$store.commit(keyMapsMutation.UPDATE_VWO_EXPERIMENTS, ___);
        }
      })
      .catch((errors) => { });
    Utility.initializeUtmAttributes();
    loadAmplitudeUnsentEvents(vwoVariant);
    Utility.promoAppliedFromCartPage();

    if(window.location.href.endsWith(Utility.getCurrentStoreFolder())) {
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
      return;
    }

    this.startupAppiCallsWrapper(() => {
      if (!LocalStorageFunc.cartId()) {
        this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {
          startupAppiCalls: () => {
            Utility.startupAppiCalls();
          },
        });
      } else {
        Utility.startupAppiCalls();
      }
    });
    
    if (isVwoVariantAvailable) {
      LocalStorageFunc.setNextGenKeyInSession();
    }
    this.checkIfShowSearchModal();
    setEvents("amplitude", "pageView", {
      Page_Name: PageNames.NEXTGEN_MENUPAGE,
      screenName: PageNames.NEXTGEN_MENUPAGE,
      previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
    });
    const element = document.getElementsByClassName("home-route");
    element[0].style.paddingTop = this.addPaddingtoTop();
    window.scrollBy(0, 10);
    this.scrollToCategoryId();
    this.hidePageLoader();
    Utility.pizzaCounter();
  },
  methods: {
    checkIfShowSearchModal() {
      let queryParams = Utility.getQueryFromUrl();
      if (queryParams["showSearchModal"] === "true") {
        this.triggerSearchModal();
      }
    },
    triggerSearchModal(e) {
      document.body.classList.add("body-stop-scroll-mobile");
      this.updateIsSearchModalOpen(true);
      // Event for separate menu
      const preEventObj = {
        category: "text search",
        screenName: PageNames.NEXTGEN_MENUPAGE,
        previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
      };
      const event_Obj = Utility.amplitudeEventObj(
        "click",
        "menu top bar",
        "-1",
        preEventObj
      );
      setEvents("amplitude", "Click", event_Obj);
      UserActivityTracking.searchClicked(0);
    },
    closeSearchModal() {
      this.updateIsSearchModalOpen(false);
    },
    hidePageLoader() {
      document.getElementById("pageLoader").style.display = "none";
    },
    previousLinkRewrite(linkRewrite = LocalStorageFunc.getSessionStorageKey('previousLinkRewrite')){
      if(Object.keys(linkRewrite).length <= 0) {
        linkRewrite = PageNames.NEXTGEN_LINKREWRITE_HOME;
      }
      return `/${linkRewrite}/`;
    },
    redirectToPreviousPage() {
      const preEventObj = {
        category: "back click",
        screenName: PageNames.NEXTGEN_MENUPAGE,
        previousScreenname: PageNames.NEXTGEN_HOMEPAGE,
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "menu top bar",
        "-1",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);
      const cartFlag = LocalStorageFunc.getStorageValue("isFromNxgCart");
      if(cartFlag == "true"){
        Utility.sendToNextGenCart();
        return;
      }
      window.location.href =
        projectBasePathWithFolder +
        this.previousLinkRewrite() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
    },
    scrollToCategoryId() {
      let queryParams = Utility.getQueryFromUrl();
      let categoryName = "",
        categoryId = "";
      let keyFound = false;
      const menuCategory = queryParams["scrollTo"] 
                            || queryParams["cat_id"]
                            || queryParams["categoryId"]
                            || "";
      const topValMargin = 150;
      if (menuCategory !== "") {
        setTimeout(() => {
          if (menuCategory === "menuTop") {
            Utility.scrollUptoMenuTop(150);
          } else {
            let productItems =
              this.$store.getters[keyMapsGetter.GET_PRODUCT_ITEM_FOR_BOTTOMBAR];
            for (const product in productItems) {
              if (
                Number(productItems?.[product]?.categoryId) ===
                Number(menuCategory)
              ) {
                keyFound = true;
                categoryName = productItems?.[product]?.categoryName;
                categoryId = productItems?.[product]?.categoryId;
                break;
              }
            }
            if (keyFound) {
              Utility.scrollUptoTo("element_catg_" + menuCategory, topValMargin);
            } else {
              Utility.scrollUptoMenuTop(topValMargin);
            }
          }
        }, 0);
      } else {
        // Hack for hiding all other categories in case no scrollParam is passed
        let landingPageKey = LocalStorageFunc.getSessionStorageKey("LANDING_PAGE");
        if(typeof landingPageKey === "string" && landingPageKey.startsWith('/menu')) {
          Utility.scrollToFromSessionKey();
        }
        else {
          Utility.scrollUptoMenuTop(150);
        }
      }

      setTimeout(() => {
        if (!keyFound) {
          categoryName = "default";
          categoryId = -1;
        }
        this.$store.commit(keyMapsMutation.UPDATE_SELECTED_MENU_CATEGORY, {
          category: categoryName,
          id: categoryId,
        });
      }, 0);
      let url = Utility.addUpdateParam(
        window.location.href,
        "scrollTo",
        "menuTop"
      );
      url = Utility.addUpdateParam(url, "showSearchModal", false);
      Utility.setSessionStorageValue("nextgenhomepage", url);
    },
    addPaddingtoTop() {
      let vwoExperimentName = LocalStorageFunc.getSessionStorageKey("VWO_PWA_V2_VARIATIONS");
      let exp = vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (exp === "nextgen_variant_x") {
        return "111px";
      }
      return "150px"
    },
    isFloatingMenuVariant() {
      let vwoExperimentName = LocalStorageFunc.getSessionStorageKey("VWO_PWA_V2_VARIATIONS");
      let exp = vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (exp === "nextgen_variant_x") {
        return true;
      }
      else {
        return false;
      }
    },
    isSeparateMenuVariant() {
      let vwoExperimentName = LocalStorageFunc.getSessionStorageKey("VWO_PWA_V2_VARIATIONS");
      let exp = vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y
      ) {
        return true;
      }
      else {
        return false;
      }
    },
    startupAppiCallsWrapper(inputFunc) {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then((PermissionStatus) => {
            if (PermissionStatus.state == "granted") {
              LocalStorageFunc.setIsLocationPermissionGiven();
              this.$store.commit(keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN, true);
              //console.log("allowed")
            } else if (PermissionStatus.state == "prompt") {
              //console.log("prompt");
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
              this.$store.commit(keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN, false);
            } else {
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
              this.$store.commit(keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN, false);
              //console.log("denied");
            }
            inputFunc();
          });
      } else {
        inputFunc();
      }
    },
    getTimeSpentEventFireTime() {
      return ((window?._siteProps_?.props?.amplitudeTimeSpentEventFireTime) ? (window?._siteProps_?.props?.amplitudeTimeSpentEventFireTime) : "3");
    },
    updateIsSearchModalOpen(val) {
      this.$store.commit(keyMapsMutation.UPDATE_IS_SEARCH_MODAL_OPEN, val);
    },
  },
  computed: {
    appConfig() {
      if (this.amplitudeTimeSpentIsNotProcessed) {
        this.amplitudeTimeSpentIsNotProcessed = false;
        let eventFireTime = this.getTimeSpentEventFireTime();
        setTimeout(() => {
          setEvents("amplitude", "time_spent", {
            eventCategory: 'time spent',
            fired_after: eventFireTime,
            Events_time_stamp: new Date().getTime(),
            Page_Name: PageNames.NEXTGEN_MENUPAGE
          });
        }, eventFireTime * 1000); //time in milliseconds
      }
    },
    isSearchModalOpen() {
      return this.$store.state.ProductItems.isSearchModalOpen;
    },
    getBackgroundImage() {
      const { backgroundImage = '' } = this.modulePropsData;
      let backgroundImageCss = '';
      if(backgroundImage !== '') {
        backgroundImageCss = `
          background-image: url('${backgroundImage}');
          background-repeat: no-repeat;
          background-size: cover;
        `;
      }
      return backgroundImageCss;
    },
    showAlertModal() {
      return this.$store.state.DynamicWidget.showAlertModal;
    },
  }
};
</script>

<style></style>
